import { Link } from 'react-router-dom';

export default function Card({item}){
    return(
        <div className='live-main'>
            <div className='live-title'>
                <h2>{item.storytype}</h2>
                <p>{item.storylocation}</p>
            </div>
            <div className='live-power'>
                <h1>{item.storygen} KW</h1>
                <div className='sun-image'>
                    <img src='./images/sun.svg' alt=''/>
                </div>
            </div>
            <div className='live-story-image'>
                <img src={`${process.env.React_APP_API_URL}/upload/${item.image1}`} alt='Site'/>
            </div>
            <div className='live-read'>
                <Link to={`/story/${btoa("Trulle_"+item.storyid+"_AmazingPower")}`} state={{storyData:item}}>
                    <p>Read More</p>
                    <div className='live-read-arrow'>
                        <img src='./images/live-arrow.svg' alt='Site'/>
                    </div>
                </Link>
            </div>
        </div>
    );
    }